module.exports = __webpack_public_path__ + "img/Deconvolute.8c6fd3ae.png";